<div class="ticker-wrap">
    <div class="ticker">
        <span class="ticker__item" *ngFor="let event of events">
            <span class="flex items-center text-sm font-medium text-gray-600 dark:text-gray-400">
                <span [ngClass]="event.dotColor" class="flex shrink-0 w-2 h-2 rounded-full mr-2"></span>
                <span [ngClass]="event.textColor" class="font-bold mr-1.5 lowercase">{{ event.message }}:</span>
                <span>{{ event.detail }}</span>
                <span class="ml-2 text-xs font-normal opacity-60">({{ event.time }})</span>
            </span>
        </span>
        <!-- Duplicate for loop -->
        <span class="ticker__item" *ngFor="let event of events">
            <span class="flex items-center text-sm font-medium text-gray-600 dark:text-gray-400">
                <span [ngClass]="event.dotColor" class="flex shrink-0 w-2 h-2 rounded-full mr-2"></span>
                <span [ngClass]="event.textColor" class="font-bold mr-1.5 lowercase">{{ event.message }}:</span>
                <span>{{ event.detail }}</span>
                <span class="ml-2 text-xs font-normal opacity-60">({{ event.time }})</span>
            </span>
        </span>
    </div>
</div>
